module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/components/app/app.component.html
// module id = ../../../../../src/app/components/app/app.component.html
// module chunks = main